import React from 'react';

import { MenuContext } from './MenuContext';

export default function useMenu() {
  const context = React.useContext(MenuContext);
  return context;
}
